import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_57: FaireProductEntity = {
  token: "starter_collection_57",
  type: "product",
  name: "'\"Frizzle\" 2L Jug'",
  brandName: "Graza",
  imageUrl: "",
  priceDollars: 32,
  msrpDollars: 64,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
